import { render, staticRenderFns } from "./FacebookBlack.vue?vue&type=template&id=2c2c9c12&scoped=true&"
import script from "./FacebookBlack.vue?vue&type=script&lang=js&"
export * from "./FacebookBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c9c12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c2c9c12')) {
      api.createRecord('2c2c9c12', component.options)
    } else {
      api.reload('2c2c9c12', component.options)
    }
    module.hot.accept("./FacebookBlack.vue?vue&type=template&id=2c2c9c12&scoped=true&", function () {
      api.rerender('2c2c9c12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/icons/social/FacebookBlack.vue"
export default component.exports